import {SUMMARY_PAYMENTS_STATUSES} from '../payments';
import type {BookingSummary} from './types';

export function getArePaymentsAvailable(
  summary?: Partial<BookingSummary> | null,
): boolean {
  return [
    summary?.property_protection,
    summary?.taxes,
    summary?.booking_payments,
    summary?.upselling,
  ].some(payment => payment?.active);
}

export function getAreAllPaymentsCompleted(
  summary?: Partial<BookingSummary> | null,
): boolean {
  return [summary?.booking_payments, summary?.property_protection, summary?.taxes]
    .filter(payment => payment?.active)
    .every(
      payment =>
        payment?.status === SUMMARY_PAYMENTS_STATUSES.complete ||
        payment?.status === SUMMARY_PAYMENTS_STATUSES.payOnArrival,
    );
}

export function getIsGuestRegistrationOnly(
  summary?: Partial<BookingSummary> | null,
): boolean {
  return [summary?.property_protection, summary?.taxes, summary?.upselling].every(
    feature => !feature?.active,
  );
}
